import { finalDismissalOf, type DismissStrip } from '@littlebird/action-cards';

import { pluralize } from '@/lib/date-utils';

import type { DismissToastMode } from './DismissToast';

export const outcomeLabel = (strip: DismissStrip, mode: DismissToastMode) => {
  const count = strip.targets.length;
  if (count > 1) return `${count} ${pluralize(count, 'card')} dismissed`;
  const finalDismissal = finalDismissalOf(strip.targets[0]);
  if (finalDismissal) return finalDismissal.label;
  return mode === 'list' ? 'Dismissed' : 'Discarded';
};
